export const locationsData = [
    {
        id:126,
        name:"PLANTA BAJA",
        coordinates:"173.85 472.18 457.75 472.18 457.75 508 173.85 508 173.85 477.7 173.85 472.18",
        available:3,
        reserved:0,
        unavailable:1,
        color:"31af67"
    },
    {
        id:127,
        name:"PISO 1",
        coordinates:"173.85 470.18 457.75 470.18 457.75 437.08 173.85 437.08 173.85 462.05 173.85 470.18",
        available:4,
        reserved:0,
        unavailable:0,
        color:"31af67"
    },
    {
        id:128,
        name:"PISO 2",
        coordinates:"457.47 437.08 173.62 437.08 173.62 404.39 457.47 404.39 457.47 431.7 457.47 437.08",
        available:3,
        reserved:0,
        unavailable:1,
        color:"31af67"
    },
    {
        id:129,
        name:"PISO 3",
        coordinates:"457.32 370.41 173.8 370.41 173.8 404.25 457.32 404.25 457.32 375.34 457.32 370.41",
        available:3,
        reserved:0,
        unavailable:1,
        color:"31af67"
    },
    {
        id:130,
        name:"PISO 4",
        coordinates:"457.32 370.41 173.8 370.41 173.8 337.23 457.32 337.23 457.32 365.81 457.32 370.4",
        available:3,
        reserved:0,
        unavailable:1,
        color:"31af67"
    },
    {
        id:131,
        name:"PISO 5",
        coordinates:"457.65 338.22 173.8 338.22 173.8 304.38 457.65 304.38 457.65 330.99 457.65 338.22",
        available:3,
        reserved:0,
        unavailable:1,
        color:"31af67"
    },
    {
        id:132,
        name:"PISO 6",
        coordinates:"457.98 304.38 173.8 304.38 173.8 271.2 457.98 271.2 457.98 297.48 457.98 304.38",
        available:2,
        reserved:0,
        unavailable:2,
        color:"31af67"
    },
    {
        id:133,
        name:"PISO 7",
        coordinates:"457.32 270.54 173.8 270.54 173.8 238.35 457.32 238.35 457.32 266.27 457.32 270.54",
        available:2,
        reserved:0,
        unavailable:2,
        color:"31af67"
    },
    {
        id:134,
        name:"PISO 8",
        coordinates:"457.65 237.69 173.8 237.69 173.8 204.51 457.65 204.51 457.65 231.45 457.65 237.69",
        available:2,
        reserved:0,
        unavailable:2,
        color:"31af67"
    },
    {
        id:135,
        name:"PISO 9",
        coordinates:"457 205.15 173.95 205.15 173.95 171.89 457 171.89 457 200.26 457 205.15",
        available:2,
        reserved:0,
        unavailable:2,
        color:"31af67"
    },
    {
        id:136,
        name:"PISO 10",
        coordinates:"456.68 171.89 174.28 171.89 174.28 138.3 456.68 138.3 456.68 167.65 456.68 171.89",
        available:2,
        reserved:0,
        unavailable:2,
        color:"31af67"
    },
    {
        id:137,
        name:"PISO 11",
        coordinates:"457 138.3 174.28 138.3 174.28 105.69 457 105.69 457 132.76 457 138.3",
        available:2,
        reserved:0,
        unavailable:2,
        color:"31af67"
    },
    {
        id:138,
        name:"PISO 12",
        coordinates:"457 105.36 173.95 105.36 173.95 73.73 457 73.73 457 99.17 457 105.36",
        available:3,
        reserved:0,
        unavailable:1,
        color:"31af67"
    },
]